/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import type AbilitiesService from "ember-can/services/abilities";
import type ForcJournalEventBasedComponent from "../abstract/journal-event-based-component";
import type { Signature as ForcProviderBaseSignature } from "./base/index";
import type Patient from "parog-web/models/patient";

export interface Signature {
  Args: {
    patient?: Patient;
    changeset?: unknown;
    formclass?: unknown;
    dontUseTextWidthLimit?: unknown;
    headerHidden?: boolean;
    background?: unknown;
    forcComponent: ForcJournalEventBasedComponent;
    title?: string;
    class?: string;
    smallFooter?: boolean;
  };
  Blocks: {
    header: [];
    content: [baseProvider: ForcProviderBaseSignature["Blocks"]["default"][0]];
  };
}

export default class ForcProviderComponent extends Component<Signature> {
  @service declare abilities: AbilitiesService;

  get forcComponent() {
    return this.args.forcComponent;
  }

  constructor(owner: unknown, args: Signature["Args"]) {
    super(owner, args);
    if (!this.args.forcComponent) {
      throw `Mandatory parameter missing in ${this.constructor.name}: forcComponent`;
    }
  }

  get displayTitle() {
    return this.args.title
      ? this.args.title
      : this.forcComponent.forcDisplayName;
  }

  get displayArchiveButton() {
    return (
      this.abilities.can("archive form", this.forcComponent.fullComponentId) &&
      this.forcComponent.isEditMode &&
      !this.forcComponent.isReadOnly
    );
  }

  @action
  onSubmit(event) {
    event.preventDefault();
    this.forcComponent.onSubmit.perform();
  }
}
